<template>
  <div class="main">
    <div class="title">
      <p>工商信息</p>
    </div>
    <div class="table mb-24">
      <el-row>
        <el-col :span="3">法定代表人</el-col>
        <el-col :span="5">{{ info.legalPersonName||'--' }}</el-col>
        <el-col :span="3">经营状态</el-col>
        <el-col :span="5">{{ info.regStatus||'--' }}</el-col>
        <el-col :span="3">成立日期</el-col>
        <el-col :span="5">
          <span v-if="info.estiblishTime">{{ info.estiblishTime.slice(0,10) }}</span>
          <span v-else>--</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">注册资本</el-col>
        <el-col :span="5">{{ info.regCapital||'--' }}</el-col>
        <el-col :span="3">实缴资本</el-col>
        <el-col :span="5">{{ info.actualCapital||'--' }}</el-col>
        <el-col :span="3">核准日期</el-col>
        <el-col :span="5">
          <span v-if="info.approvedTime">{{ info.approvedTime.slice(0,10) }}</span>
          <span v-else>--</span>
          </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">统一社会信用代码</el-col>
        <el-col :span="5">{{ info.creditCode||'--' }}</el-col>
        <el-col :span="3">组织机构代码</el-col>
        <el-col :span="5">{{ info.orgNumber||'--' }}</el-col>
        <el-col :span="3">工商注册号</el-col>
        <el-col :span="5">{{ info.regNumber||'--' }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="3">纳税人识别号</el-col>
        <el-col :span="5">{{ info.taxNumber||'--' }}</el-col>
        <el-col :span="3">企业类型</el-col>
        <el-col :span="5">{{ info.companyOrgType||'--' }}</el-col>
        <el-col :span="3">营业期限</el-col>
        <el-col :span="5">
          <span v-if="info.estiblishTime" class="mr-5">{{info.estiblishTime.slice(0,10) }} 至 </span>
          <span v-if="info.toTime">{{ info.toTime.slice(0,10) }}</span>
          <span v-else>无固定期限</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">登记机关</el-col>
        <el-col :span="5">{{ info.regInstitute||'--' }}</el-col>
        <el-col :span="3">人员规模</el-col>
        <el-col :span="5">{{ info.staffNumRange||'--' }}</el-col>
        <el-col :span="3">参保人数</el-col>
        <el-col :span="5">{{ info.socialStaffNum||'--' }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="3">曾用名</el-col>
        <el-col :span="5">{{ info.historyNames||'--' }}</el-col>
        <el-col :span="3">英文名</el-col>
        <el-col :span="5">{{ info.property3||'--' }}</el-col>
        <el-col :span="3">简称</el-col>
        <el-col :span="5">{{ info.alias||'--' }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="3">所属地区</el-col>
        <el-col :span="5">{{ getBase(info.base) }}</el-col>
        <el-col :span="3">所属行业</el-col>
        <el-col :span="13">{{ info.industry||'--' }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="3">企业地址</el-col>
        <el-col :span="21">{{ info.regLocation||'--' }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="3">经营范围</el-col>
        <el-col :span="21">{{ info.businessScope||'--' }}</el-col>
      </el-row>
    </div>
    <div class="title">
      <p>企业股东</p>
    </div>
    <div class="mb-24">
      <el-table :data="shareholder.tableData" border :header-cell-style="{background: '#EDF0F4',color: '#333'}">
        <el-table-column type="index" label="序号" align="center" width="50" />
        <el-table-column label="股东(发起人)" prop="name" align="center">
          <template slot-scope="scope">{{ scope.row.name||'--' }}</template>
        </el-table-column>
        <el-table-column label="出资比例" prop="capital" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.capital&&scope.row.capital.length>0">{{ scope.row.capital[0].percent }}</span>
          </template>
        </el-table-column>
        <el-table-column label="认缴出资额" prop="capital" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.capital&&scope.row.capital.length>0">{{ scope.row.capital[0].amomon }}</span>
          </template>
        </el-table-column>
        <el-table-column label="认缴出资日期" prop="capital" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.capital&&scope.row.capital.length>0">{{ scope.row.capital[0].time||'--' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="center">
        <pagination :pageNum="shareholder.pageNum" :total="shareholder.total" @currentChange="val => handleCurrentChange(val, 1)"/>
      </div>
    </div>
    <div class="title">
      <p>主要人员</p>
    </div>
    <div class="mb-24">
      <el-table :data="personnel.tableData" border :header-cell-style="{background: '#EDF0F4',color: '#333'}">
        <el-table-column type="index" label="序号" align="center" width="50" />
        <el-table-column label="姓名" prop="name" align="center">
          <template slot-scope="scope">{{ scope.row.name||'--' }}</template>
        </el-table-column>
        <el-table-column label="职位" prop="typeJoin" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.typeJoin&&scope.row.typeJoin.length>0">{{ scope.row.typeJoin.join('，') }}</div>
            <div v-else>--</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="center">
        <pagination :pageNum="personnel.pageNum" :total="personnel.total" @currentChange="val => handleCurrentChange(val, 2)"/>
      </div>
    </div>
    <div class="title">
      <p>变更记录</p>
    </div>
    <div class="mb-24">
      <el-table :data="record.tableData" border :header-cell-style="{background: '#EDF0F4',color: '#333'}">
        <el-table-column type="index" label="序号" align="center" width="50" />
        <el-table-column label="变更日期" prop="changeTime" align="center">
          <template slot-scope="scope">{{ scope.row.changeTime||'--' }}</template>
        </el-table-column>
        <el-table-column label="变更项目" prop="changeItem" align="center">
          <template slot-scope="scope">{{ scope.row.changeItem||'--' }}</template>
        </el-table-column>
        <el-table-column label="变更前" prop="contentBefore" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.contentBefore" v-html="scope.row.contentBefore" class="div-html"></div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column label="变更后" prop="contentAfter" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.contentAfter" v-html="scope.row.contentAfter" class="div-html"></div>
            <div v-else>--</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="center">
        <pagination :total="record.total" @currentChange="val => handleCurrentChange(val, 3)"/>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/pagination/'
import { areaCode } from '@/base/areaCode.js'
import { holder, keyMan, changeInfo } from '../api/index.js'

export default {
  name: 'Company',
  components: {
    Pagination
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      name: this.$route.query.name,
      areaCode: areaCode,
      shareholder: {
        tableData: [],
        pageNum: 1,
        total: 0
      },
      personnel: {
        tableData: [],
        pageNum: 1,
        total: 0
      },
      record: {
        tableData: [],
        pageNum: 1,
        total: 0
      }
    }
  },

  mounted () {
    this.holder()
    this.keyMan()
    this.changeInfo()
  },
  computed: {
  },
  methods: {
    holder () {
      var data = {
        name: this.name,
        pageNum: this.shareholder.pageNum
      }
      holder(data).then(res => {
        if (res.data) {
          this.shareholder.tableData = res.data.items
          this.shareholder.total = res.data.total
        } else {
          this.shareholder.tableData = []
          this.shareholder.total = 0
        }
      })
    },
    keyMan () {
      var data = {
        name: this.name,
        pageNum: this.personnel.pageNum
      }
      keyMan(data).then(res => {
        if (res.data) {
          this.personnel.tableData = res.data.items
          this.personnel.total = res.data.total
        } else {
          this.personnel.tableData = []
          this.personnel.total = 0
        }
      })
    },
    changeInfo () {
      var data = {
        name: this.name,
        pageNum: this.record.pageNum
      }
      changeInfo(data).then(res => {
        if (res.data) {
          this.record.tableData = res.data.items
          this.record.total = res.data.total
        } else {
          this.record.tableData = []
          this.record.total = 0
        }
        this.$nextTick(() => {
          var html = document.getElementsByClassName('div-html')
          for (var i = 0; i < html.length; i++) {
            html[i].innerHTML = html[i].innerHTML.replace(/(<\/?a.*?>)/g, '')
          }
        })
      })
    },
    getBase (val) {
      var base = '--'
      if (val) {
        for (var i = 0; i < this.areaCode.length; i++) {
          if (val === this.areaCode[i].base) {
            base = this.areaCode[i].name
            break
          }
        }
      }
      return base
    },
    handleCurrentChange (val, sign) {
      if (sign === 1) {
        this.shareholder.pageNum = val
        this.holder()
      } else if (sign === 2) {
        this.personnel.pageNum = val
        this.keyMan()
      } else if (sign === 3) {
        this.record.pageNum = val
        this.changeInfo()
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.title {
  padding: 20px 0;
  p {
    font-size: 16px;
    color: #333;
    border-left: 4px #1890ff solid;
    padding-left: 5px;
    font-weight: bold;
  }
}

.mb-24 {
  margin-bottom: 24px;
}

.table {
  border: 1px solid #e1e7ed;
  .el-row + .el-row {
    border-top: 1px solid #e1e7ed;
  }
  .el-row {
    display: flex;
    .el-col {
      padding: 20px;
      color: #666666;
      display: inline-flex;
      align-items: center;
    }
    .el-col-3 {
      background: #f4f6f8;
      color: #333;
      font-weight: bold;
    }
    .el-col + .el-col {
      border-left: 1px solid #e1e7ed;
    }
  }
}

/deep/.el-table--border,
/deep/.el-table--group {
  border-color: #e1e7ed;
}
/deep/.el-table td,
/deep/.el-table th.is-leaf {
  border-color: #e1e7ed;
}
/deep/.el-table--border th,
/deep/.el-table--border th.gutter:last-of-type {
  border-color: #e1e7ed;
}
/deep/.el-table--border td,
/deep/.el-table--border th {
  border-color: #e1e7ed;
}
</style>
